/**
 * @generated SignedSource<<ca7c9f5b499d4f0d385a1f2326db2145>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SimplePage_page$data = {
  readonly breadcrumbs: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"Breadcrumb_data">;
  } | null | undefined> | null | undefined;
  readonly components: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly " $fragmentSpreads": FragmentRefs<"ArchiveList_component">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly path: string | null | undefined;
  readonly " $fragmentType": "SimplePage_page";
};
export type SimplePage_page$key = {
  readonly " $data"?: SimplePage_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"SimplePage_page">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SimplePage_page",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "ComponentConnection",
      "kind": "LinkedField",
      "name": "components",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ComponentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ArchiveList_component"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "components(first:1000)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Breadcrumb",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Breadcrumb_data"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "SimplePage",
  "abstractKey": null
};

(node as any).hash = "9aa2c6829bc45a937607d2ed27d3b3eb";

export default node;
